import { MagazineBlocksLocalized } from "../types";

export const localized: MagazineBlocksLocalized = (window as any)
	._MAGAZINE_BLOCKS_;
